export const CURRENCY_SYMBOLS = {
  AUD: '$',
  CAD: '$',
  EUR: '€',
  GBP: '£',
  USD: '$',
  NZD: '$',
  NGN: '₦',
  ZAR: 'R '
}

export const SUPPORTED_CURRENCIES = Object.keys(CURRENCY_SYMBOLS)
